// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.b1QDzykjYNcbrxIg{display:inline-block;background:var(--py-neutral-7);padding:8px;color:#fff;border-radius:4px;text-align:left;width:max-content;box-sizing:border-box;z-index:9999999;word-break:break-word}.b1QDzykjYNcbrxIg .VIyfuIeFjqoEiCHy{border-top:1px solid #fff;margin:2px 0}.A_X5bmU9nYteuZ08{max-width:160px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `b1QDzykjYNcbrxIg`,
	"line": `VIyfuIeFjqoEiCHy`,
	"small": `A_X5bmU9nYteuZ08`
};
export default ___CSS_LOADER_EXPORT___;
